// `frontend-vite-migration` Phase 4. Replaces `next/dynamic({ ssr: false, loading })`: Vite has
// no SSR pass to opt out of (the whole app is client-rendered), so `ssr:
// false` itself carries no meaning any more — only the "keep this heavy
// dependency out of the initial bundle, show a fallback while it loads"
// behavior needs porting. `React.lazy` requires its own `<Suspense>`
// ancestor; this wraps that requirement so call sites render the returned
// component directly, same ergonomics as `next/dynamic` gave them.
import { lazy, Suspense, type ComponentType, type ReactNode } from 'react';

export function lazyWithFallback<P extends object>(
	loader: () => Promise<ComponentType<P>>,
	fallback: ReactNode = null,
): ComponentType<P> {
	const LazyComponent = lazy(() => loader().then((component) => ({ default: component })));
	return function LazyWithFallback(props: P) {
		return (
			<Suspense fallback={fallback}>
				<LazyComponent {...props} />
			</Suspense>
		);
	};
}
